import * as React from 'react';
const IconInfo = (props) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '28px', height: '28px' }}
    {...props}
  >
    <circle cx={14} cy={14} r={12.5} stroke="#003764" strokeWidth={3} />
    <path
      d="M12.5632 19.52V11.84C12.5632 10.88 13.1632 10.24 14.0032 10.24C14.8432 10.24 15.4432 10.88 15.4432 11.84V19.52C15.4432 20.48 14.8432 21.12 14.0032 21.12C13.1632 21.12 12.5632 20.48 12.5632 19.52ZM14.0032 5.92C14.8632 5.92 15.6232 6.66 15.6232 7.5C15.6232 8.4 14.9032 9.16 14.0032 9.16C13.1432 9.16 12.3832 8.38 12.3832 7.5C12.3832 6.68 13.1432 5.92 14.0032 5.92Z"
      fill="#003764"
    />
  </svg>
);
export default IconInfo;
